module.exports = __webpack_public_path__ + "media/images/new_home/mobile-business-list-photo-caeece84b6bf7fc99c320cc3c1f7afcb.jpg";